.container {
  margin: 1.6rem 1.6rem 0;
  display: flex;
  flex-direction: column;
  flex: 1;
  max-width: 100%;
}

.actions-row {
  display: flex;
  justify-content: flex-end;
}

.content {
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
  display: flex;
  flex-direction: column;
}
